import {gql} from "@apollo/client";

export const ProfileDashboard = gql`
    query ProfileDashboard {
        profile {
            id
            name
            dashboardConfig
        }
    }`
